import { Ref, ref } from 'vue';

const lastStep: Ref<string> = ref('');
const step: Ref<string> = ref('theme');
const answer: Ref<string> = ref<string>('');
const done: Ref<boolean> = ref(false);
const question: Ref<string> = ref('');
const color: Ref<string> = ref('#0435A0');
const theme: Ref<string | undefined> = ref('flower');
const pptNode: Ref<any> = ref([
  {
    id: 'track-1-0-0',
    elements: [],
    background: {
      type: 'solid',
      color: '#fff'
    }
  }
]);
const isDocx: Ref<number> = ref(0);
const showLeftTabBar = true;
const nodeJson: Ref<any> = ref<any>({});
const slideJson: Ref<any> = ref<any>([]);
const isPerinstall: Ref<boolean> = ref<boolean>(false);

const showLodingDialog: Ref<boolean> = ref<boolean>(false);

const openLodingDialog = () => {
  showLodingDialog.value = true;
};

const closeLodingDialog = () => {
  showLodingDialog.value = false;
};

export {
  lastStep,
  step,
  answer,
  done,
  question,
  color,
  theme,
  pptNode,
  isDocx,
  nodeJson,
  slideJson,
  isPerinstall,
  showLeftTabBar,
  showLodingDialog,
  openLodingDialog,
  closeLodingDialog
};
